import { render, staticRenderFns } from "./SolePropG.vue?vue&type=template&id=753ac6d9"
import script from "./SolePropG.vue?vue&type=script&lang=js"
export * from "./SolePropG.vue?vue&type=script&lang=js"
import style0 from "./SolePropG.vue?vue&type=style&index=0&id=753ac6d9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports